module.exports = __webpack_public_path__ + "img/img-2.f6501ac9.jpg";